import { Group, Identifier } from '../../models/entities';
import { getGroupGuidsOnMap } from './getGroupGuidsOnMap';
import { Dictionary } from '../../models/Dictionary';

export const getIdentifiersDictionaryForGroupsOnMap = (groups: Group[]) => {
    const identifiersByGroup: Dictionary<Identifier[]> = {};
    getGroupGuidsOnMap(groups).forEach((guid) => {
        let identifiers = groups.find((group) => group.guid === guid)?.identifierCollection ?? [];
        let children = groups.filter((g) => g.parentGUID === guid);
        while (children.length > 0) {
            identifiers = identifiers.concat(children.flatMap((c) => c.identifierCollection));
            const childrenGuids = children.map((c) => c.guid);
            children = groups.filter((g) => childrenGuids.indexOf(g.parentGUID) >= 0);
        }
        identifiersByGroup[guid] = identifiers;
    });
    return identifiersByGroup;
};
